<template>
  <v-row :no-gutters="embed" justify="center">
    <!-- loading -->
    <v-overlay v-if="chartLoading && forceUnLoading!=true">
      <v-progress-circular indeterminate color="purple" size="70" width="7"></v-progress-circular>
    </v-overlay>

    <!-- chart -->
    <v-col cols="12">
      <iframe :id="chartElId" style="width:100%;border:1px solid grey;overflow: hidden;"></iframe>
      <!-- <div :id="chartElId"></div> -->
      <!-- <div :id="chartElId" v-html="dataSource"></div> -->
    </v-col>
  </v-row>
</template>
<script>
// HTML嵌入
import { userFileRead } from '@/plugins/api';
import $ from '@/assets/jquery/jquery-vendor.js';

export default {
  props: ['forceUnLoading', 'tool', 'embed', 'exportFileName', 'dataSourceParam', 'chartContainerId', 'status', 'lazy'],
  data () {
    return {
      chartLoading: true,
      dataSource: null
    }
  },
  computed: {
    chartElId () { return this.chartContainerId || 'chartContainer' }
  },
  async mounted () {
    try {
      await this.init();
    } finally {
      if (this.status) this.status.ready = true
    }
  },
  methods: {
    async init () {
      await userFileRead({ ...this.dataSourceParam, parse: false }).then(res => this.dataSource = res.data)
      let frame = document.getElementById(this.chartElId).contentWindow.document;
      frame.open();
      frame.write(this.dataSource);
      frame.close();

      let height = $(frame).height();
      $(`#${this.chartElId}`).height(height);
      this.chartLoading = false;
    }
  }
}

</script>